import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useCallRecordingControllerGetCallRecordingQuery } from '@shared/services/apiService/apiService';
import { useAppSelector } from '@shared/store';
import { selectors } from '@shared/store/ducks/auth';

export const RecordingRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const isAuth = useAppSelector(selectors.getAccessToken);

  const { data } = useCallRecordingControllerGetCallRecordingQuery(
    { id: id! },
    { skip: !id || !isAuth },
  );

  useEffect(() => {
    if (data?.url) {
      // Hand the browser straight to the presigned file — it opens the native audio view.
      window.location.href = data.url;
    }
  }, [data]);

  if (!isAuth) {
    return <Navigate to="/sign-in" replace />;
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <CircularProgress />
    </Box>
  );
};
